import { IOnboardingDocuments } from '@efex-services/documents/documentsSvc';
import { IDocumentTypeId } from '@efex-services/documents/types';
import {
  ProofOfAddressDocumentReducerAction,
  ProofOfAddressDocumentReducerCases,
  ProofOfAddressDocumentReducerState,
} from './proofOfAddressDocumentReducer.types';

const CASES = {
  [ProofOfAddressDocumentReducerCases.SET_DOCUMENT]: (
    state: ProofOfAddressDocumentReducerState,
    action: ProofOfAddressDocumentReducerAction
  ): ProofOfAddressDocumentReducerState => {
    const documentToSave = (action.payload as IOnboardingDocuments[]).find(
      (document) =>
        document.document.type?.id === IDocumentTypeId.PROOF_OF_ADDRESS
    );

    if (documentToSave) {
      return [documentToSave];
    }

    return state;
  },

  [ProofOfAddressDocumentReducerCases.DELETE_DOCUMENT]:
    (): ProofOfAddressDocumentReducerState => [],
};

export default CASES;
